/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useRef, useState, useEffect } from 'react';
import { Paginator } from 'primereact/paginator';
import { Sidebar } from 'primereact/sidebar';
import { Dialog } from 'primereact/dialog';
import QRCode from 'qrcode.react';
// import AddEditUser from './AddEditUser';
import { handleGetRequest } from '../../services/GetTemplate';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import './FitnessCertificateManagement.css';
import DeleteIcon from '../../assets/icons/delete.svg';
import { toast } from 'react-toastify';

import { handleDeleteRequest } from '../../services/DeleteTemplate';
import { useNavigate } from 'react-router-dom';
import SuccessLoader from '../../components/SuccessLoader';
import { baseURL } from '../../Config';
import { handlePostRequest } from '../../services/PostTemplate';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';

function FitnessCertificateManagement() {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(6);
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editAble, setEditAble] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [roleIDOptions, setroleIDOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [showSuccess, setShowSuccess] = useState(false);
    const menuRefs = useRef(new Map());
    const [downloadingIds, setDownloadingIds] = useState([]);
    const [qrLoadingIds, setQrLoadingIds] = useState([]);
    const [qrDialogVisible, setQrDialogVisible] = useState(false);
    const [qrCodeValue, setQrCodeValue] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [searchFilters, setSearchFilters] = useState({
        vehicleNumber: null,
        cfxNumber: null,
        vehicleTypeId: null,
        startDate: null,
        endDate: null,
        vehicleTypeId: null,
        paymentMethodId: null,
        requestStatusId: null
    });
    const [vehivleList, setVehicleList] = useState();
    const [methodList, setMethodList] = useState();
    const [statusList, setStatusList] = useState();

    const navigate = useNavigate();

    const handleDelete = async (row) => {
        setShowSuccess(true);
        try {
            const response = await dispatch(handleDeleteRequest(`/api/User/Delete?id=${row.id}`, true, true));
            if (response?.success) {
                setDeleteDialogVisible(false);
                setUserToDelete(null);
                fetchFitnessCertificateManagement(page);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        } finally {
            setShowSuccess(false);
        }
    };

    const fetchFitnessCertificateManagement = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const currentDate = new Date().toISOString().split('T')[0];
            const DEFAULT_START_DATE = "2020-02-01";

            
            const requestBody = {
                pageNumber: pageNumber,
                pageSize: rows,
                vehicleNumber: searchFilters?.vehicleNumber,
                vehicleTypeId: searchFilters?.vehicleTypeId,
                cfxNumber: searchFilters?.cfxNumber,
                startDate: searchFilters?.startDate || DEFAULT_START_DATE,
                endDate: searchFilters?.endDate || currentDate, // Always include an end date
                paymentMethodId: searchFilters?.paymentMethodId,
                status: searchFilters?.requestStatusId || null
            };

            const response = await dispatch(handlePostRequest(requestBody, '/api/fitness/get', false, false));

            if (response?.success && response?.data?.records) {
                setTableData(response?.data?.records || []);
                setTotalRecords(response?.data?.pagination?.totalRecords || 0);
            } else {
                setTableData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error('Error fetching fitness certificate data:', error);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        setFirst(event.first);
        setRows(event.rows);
        setPage(newPage);
        fetchFitnessCertificateManagement(newPage);  // <-- This should use filters
    };

    const handleShowQR = async (rowData) => {
        try {
            setQrLoadingIds(prev => [...prev, rowData.id]);
            
            const data = await handleGetRequest(`/api/fitness/DQR/${rowData.id}`, false);
            
            if (data?.success) {
                setQrCodeValue(data.data); 
                setTimeout(() => {
                    setQrDialogVisible(true);
                }, 100);
            } else {
                toast.error(data?.message || 'Failed to fetch QR code');
            }
        } catch (error) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to load QR code: ' + (error.message || 'Unknown error'),
                life: 3000
            });
        } finally {
            setQrLoadingIds(prev => prev.filter(id => id !== rowData.id));
        }
    };

    const onHideDialog = () => {
        setQrDialogVisible(false);
        setQrCodeValue(null);
    };

    useEffect(() => {
        // fetchFitnessCertificateManagement(page);
        fetchPermitData(1);

    }, []);

    const handleDownload = async (id) => {
        try {
            setDownloadingIds((prev) => [...prev, id]);

            const response = await fetch(`${baseURL}/api/fitness/issue/${id}`, {
                method: 'GET',
                headers: {
                    Accept: 'application/pdf',
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                throw new Error('Export failed');
            }

            const blob = await response.blob();

            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');

            toast.current?.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Certificate opened in new tab',
                life: 3000
            });
        } catch (error) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to open certificate',
                life: 3000
            });
        } finally {
            setDownloadingIds((prev) => prev.filter((item) => item !== id));
        }
    };

    const actionBodyTemplate = (rowData) => {
        const isDownloading = downloadingIds.includes(rowData.id);

        // Case: Approved + UnPaid → Show QR icon
        if (rowData?.status === "Approved" && rowData?.paymentStatus === "UnPaid") {
            const isQrLoading = qrLoadingIds.includes(rowData.id);
            return (
                <Button
                    // icon={isQrLoading ? 
                    //     "pi pi-spinner pi-spin" : 
                    //     "pi pi-qrcode"}
                     icon={isQrLoading ? (
                    <i className="pi pi-spinner pi-spin" style={{ fontSize: '1.5em' }}></i>
                ) : (
                    <i className="pi pi-qrcode" style={{ fontSize: '1.5em' }}></i>
                )}
                    onClick={() => !isQrLoading && handleShowQR(rowData)}
                    className="Btn__Dark"
                    disabled={isQrLoading}
                    // style={{ position: 'relative' }}
                    tooltip="Pay via QR Code"
                >
                </Button>
            );
        }

        // Default case → PDF button
        return (
            <Button
                icon={isDownloading ? (
                    <i className="pi pi-spinner pi-spin" style={{ fontSize: '1.5em' }}></i>
                ) : (
                    <i className="fa-solid fa-file-pdf" style={{ fontSize: '1.5em' }}></i>
                )}
                disabled={rowData?.paymentStatus === 'UnPaid' || rowData?.status !== "Approved"}
                onClick={() => handleDownload(rowData.id)}
                className="Btn__Dark"
            />
        );
    };

    const rowClassName = (rowData) => {
        return 'dataTableRow';
    };

    const template1 = {
        layout: 'CurrentPageReport',
        CurrentPageReport: (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'left', fontSize: '12px', fontWeight: '400' }}>
                    Showing{' '}
                    <span style={{ fontWeight: '700' }}>
                        {options.first} - {Math.min(options.first + options.rows - 1, options.totalRecords)}
                    </span>{' '}
                    from <span style={{ fontWeight: '700' }}>{options.totalRecords}</span> data
                </span>
            );
        }
    };

    const template2 = {
        layout: 'PrevPageLink PageLinks NextPageLink',
        PrevPageLink: (options) => {
            return <Button icon="pi pi-chevron-left" className="p-button prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        },
        PageLinks: (options) => {
            const isActive = options.currentPage === options.page;
            return (
                <button
                    type="button"
                    className={`mx-1 px-4 py-2 ${isActive ? 'isActivePage' : 'notActivePage'}`}
                    onClick={options.onClick}
                    style={{
                        width: '40.08px',
                        height: '40.08px',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '8px',
                        margin: '2px',
                        border: 'none',
                        boxShadow: isActive ? '0px 7px 16px 0px #00000024' : 'none'
                    }}
                >
                    {options.page + 1}
                </button>
            );
        },
        NextPageLink: (options) => {
            return <Button icon="pi pi-chevron-right" className="p-button-text prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        }
    };

    const onHideSidebar = () => {
        setSidebarVisible(false);
        setIsEditing(false);
        setEditData(null);
        setEditAble(false);
    };

    const getRoleID = async () => {
        const response = await handleGetRequest('/api/role');
        if (response?.success) {
            const formattedOptions = response.data.map((role) => ({
                label: role.name,
                value: role.id
            }));
            setroleIDOptions(formattedOptions);
        } 
    };

    useEffect(() => {
        getRoleID();
    }, []);

    const handleGetRoleName = (roleID) => {
        const role = roleIDOptions.find((role) => role.value === roleID);
        return role ? role.label : 'Data Entry Operator';
    };

    const handleSearchFilterChange = (field, value) => {
        // Date validation
        if (field === 'startDate') {
            // If end date exists and the new start date is after the end date, show error
            if (searchFilters.endDate && value && value > searchFilters.endDate) {
                toast.error('Start date cannot be after end date');
                return;
            }
        } else if (field === 'endDate') {
            // If start date exists and the new end date is before the start date, show error
            if (searchFilters.startDate && value && value < searchFilters.startDate) {
                toast.error('End date cannot be before start date');
                return;
            }
        }
        
        setSearchFilters((prev) => ({
            ...prev,
            [field]: value
        }));
    };
    const handleSearch = () => {
        setPage(1);
        setFirst(0);
        fetchPermitDataWithFilters(1);
    };

    const handleClearSearch = () => {
        setSearchFilters({
            vehicleNumber: null,
            cfxNumber: null,
            vehicleTypeId: null,
            startDate: null,
            endDate: null,
            paymentMethodId: null,
            requestStatusId: null
        });
        setPage(1);
        setFirst(0);
        fetchPermitData(1);
    };

    const fetchPermitDataWithFilters = async (pageNumber = 1) => {

        setLoading(true);
        try {

              const formatDate = (date) => {
                if (!date) return null;
                if (typeof date === 'string') return date;
                return date instanceof Date ? 
                    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : 
                    null;
            };
             const today = new Date();
            const currentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
            const DEFAULT_START_DATE = "2020-02-01";
            

                      let startDate = searchFilters.startDate ? formatDate(searchFilters.startDate) : DEFAULT_START_DATE;
            let endDate = searchFilters.endDate ? formatDate(searchFilters.endDate) : currentDate;
            const requestBody = {
                pageNumber: pageNumber,
                pageSize: rows,
                vehicleNumber: searchFilters.vehicleNumber || null,
                vehicleTypeId: searchFilters.vehicleTypeId,
                paymentMethodId: searchFilters?.paymentMethodId,
                cfxNumber: searchFilters.cfxNumber || null,
                 startDate: startDate,
                endDate: endDate,
                status: searchFilters?.requestStatusId || null

            };

            


            const response = await dispatch(handlePostRequest(requestBody, '/api/fitness/get', false, false));

            if (response?.success) {
                setTableData(response?.data?.records || []);
                setTotalRecords(response?.data?.pagination?.totalRecords || 0);
            } else {
                setTableData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error('Error fetching permit data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPermitData = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const currentDate = new Date().toISOString().split('T')[0];

            const requestBody = {
                pageNumber: pageNumber,
                pageSize: rows,
                vehicleNumber: null,
                vehicleTypeId: null,
                paymentMethodId: null,
                cfxNumber: null,
                startDate: currentDate,
                endDate: currentDate,
                status: null
            };

            const response = await dispatch(handlePostRequest(requestBody, '/api/fitness/get', false, false));

            if (response?.success) {
                setTableData(response?.data?.records || []);
                setTotalRecords(response?.data?.pagination?.totalRecords || 0);
            }
        } catch (error) {
            console.error('Error fetching permit data:', error);
        } finally {
            setLoading(false);
        }
    };

    const getLovsData = async () => {
        const vehiclesData = await handleGetRequest('/api/fitness/fee', false);
        if (vehiclesData?.success) {
            setVehicleList(vehiclesData?.data);
        }
        const methodsData = await handleGetRequest('/api/dropdown/payment/method', false);
        if (methodsData?.success) {
            setMethodList(methodsData?.data);
        }
        // Hardcode status values instead of fetching from API
        setStatusList([
            { id: 1, name: "Approved" },
            { id: 2, name: "Rejected" }
        ]);
    };

    useEffect(() => {
        getLovsData();
    }, []);

    const handleDownloadExcel = async () => {
        try {
            setLoading(true);

            const data = {
                vehicleNumber: searchFilters?.vehicleNumber,
                cfxNumber: searchFilters?.cfxNumber,
                vehicleTypeId: searchFilters?.vehicleTypeId,
                paymentMethodId: searchFilters?.paymentMethodId,
                startDate: searchFilters?.startDate,
                endDate: searchFilters?.endDate,
                status: searchFilters?.requestStatusId || null
            };
            const response = await fetch(`${baseURL}/api/report/fitness/excel`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`
                },
                body: JSON.stringify(data)
            });

            const contentDisposition = response.headers.get('Content-Disposition');
            const filename = contentDisposition ? contentDisposition.split('filename=')[1].replace(/"/g, '') : `PermitRequests_${new Date().toISOString().slice(0, 10)}.xlsx`;

            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Report exported successfully',
                life: 3000
            });
        } catch (error) {
            console.error('Error downloading Excel report:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            
            {showSuccess && <SuccessLoader />}
            <ConfirmDialog
                visible={deleteDialogVisible}
                onHide={() => setDeleteDialogVisible(false)}
                message="On clicking this, user details will be removed from the system. Proceed further?"
                contentClassName="content-className"
                header="Delete User"
                headerClassName="text-black"
                icon={<img src={DeleteIcon} alt="Delete" />}
                acceptLabel="Sure"
                rejectLabel="Close"
                acceptClassName="accept-button"
                rejectClassName="reject-button"
                className="custom-confirm-dialog"
                accept={() => handleDelete(userToDelete)}
            />

            <div className="grid">
                <div className="col-12 flex flex-column">
                    <div className="flex justify-content-between items-center">
                        <h2 className="text-lg font-semibold">Fitness Management</h2>
                        <div className="flex items-center gap-2">
                            {/* <span className="p-input-icon-left">
                                <i className="pi pi-search" />
                                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." className="p-inputtext-sm rounded-input" />
                            </span> */}
                            <Button label="Export Excel" onClick={handleDownloadExcel} style={{ backgroundColor: '#FF556A', border: 'none', borderRadius: '10px' }} />
                            <Button
                                label="Add New"
                                icon="pi pi-plus"
                                className="px-4 py-2 font-semibold"
                                style={{ backgroundColor: '#FF556A', border: 'none', borderRadius: '10px' }}
                                onClick={() => {
                                    navigate('/addfitness', { state: { editable: false } });
                                }}
                            />
                        </div>
                    </div>
                    <div className="mt-3 p-3 border-1 surface-border border-round">
                        <div className="grid">
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <InputText id="vehicleNumber" value={searchFilters.vehicleNumber} onChange={(e) => handleSearchFilterChange('vehicleNumber', e.target.value)} placeholder="Enter vehicle number" className="Input__Round" />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <InputText id="cfxNumber" value={searchFilters.cfxNumber} onChange={(e) => handleSearchFilterChange('cfxNumber', e.target.value)} placeholder="Enter CFX number" className="Input__Round" />
                                </span>
                            </div>

                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={vehivleList}
                                        optionValue="id"
                                        optionLabel="categoryName"
                                        id="vehicleTypeId"
                                        name="vehicleTypeId"
                                        value={searchFilters.vehicleTypeId}
                                        onChange={(e) => handleSearchFilterChange('vehicleTypeId', e.target.value)}
                                        placeholder="Select Vehicle Category"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={methodList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="paymentMethodId"
                                        value={searchFilters.paymentMethodId}
                                        onChange={(e) => handleSearchFilterChange('paymentMethodId', e.target.value)}
                                        placeholder="Select Payment Method"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={statusList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="requestStatusId"
                                        value={searchFilters.requestStatusId}
                                        onChange={(e) => handleSearchFilterChange('requestStatusId', e.target.value)}
                                        placeholder="Select Status"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>

                            <div className="col-12 md:col-3">
                                <Calendar
                                    id="startDate"
                                    name="startDate"
                                    placeholder="Select start date"
                                    dateFormat="mm/dd/yy"
                                    value={searchFilters.startDate}
                                    onChange={(e) => handleSearchFilterChange('startDate', e.value)}
                                    inputClassName="Input__Round"
                                    maxDate={searchFilters.endDate || undefined}
                                    // minDate={new Date()}
                                />
                            </div>
                            <div className="col-12 md:col-3">
                                <Calendar 
                                    id="endDate" 
                                    name="endDate" 
                                    placeholder="Select end date" 
                                    dateFormat="mm/dd/yy" 
                                    value={searchFilters.endDate} 
                                    onChange={(e) => handleSearchFilterChange('endDate', e.value)} 
                                    inputClassName="Input__Round"
                                    minDate={searchFilters.startDate || undefined}
                                />
                            </div>
                        </div>
                        <div className="flex justify-content-end gap-2 mt-3">
                            <Button label="Search" icon="pi pi-search" className="px-4 py-2 font-semibold" style={{ backgroundColor: '#ff556a', border: 'none', borderRadius: '10px' }} onClick={handleSearch} />
                            <Button label="Clear" icon="pi pi-times" className="px-4 py-2 font-semibold" style={{ borderRadius: '10px', backgroundColor: '#ff556a', border: 'none' }} onClick={handleClearSearch} />
                        </div>
                    </div>
                    <div className="card mt-3">
                        {/* <DataTable value={tableData} className="datatable-responsive shadow-md rounded-xl w-full" responsiveLayout="scroll" loading={loading}> */}
                        <DataTable value={tableData} loading={loading} responsiveLayout="scroll" className="datatable-responsive shadow-md rounded-xl" scrollable scrollHeight="45vh" stickyHeader emptyMessage={
                            <div className="w-full text-center">
                                No results found
                            </div>
                        }>
                            <Column field="vehicleNo" header="Vehicle Number" />
                            <Column field="vehicleType" header="Vehicle Category" />
                            <Column field="status" header="Status" 
                            body={(rowData) => {
                                if (rowData?.status === "Approved") {
                                    return (
                                        <div
                                            className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center bg-[#E6F4EA] text-[#3A974C] Active-column`}
                                        >
                                            Approved
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div
                                            className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center bg-[#FFEFE9] text-[#FF556A] Inactive-column`}
                                        >
                                            Rejected
                                        </div>
                                    );
                                }
                            }}
                            />
                            <Column field="cfxNo" header="CFX number" 
                            body={(rowData) => (
                                <span>{rowData?.status === "Approved" ? rowData?.cfxNo : 'N/A'}</span>
                            )}
                            />
                            <Column
                                field="paymentMethod"
                                header="Payment Method"
                                align="center"
                                body={(rowData) => {
                                    if (rowData?.status === "Approved") {
                                        return (
                                            <div
                                                className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${rowData.paymentMethod === 'Paid By Client'
                                                        ? 'bg-[#E6F4EA] text-[#3A974C] Active-column'
                                                        : rowData.paymentMethod === 'Paid By Officer'
                                                            ? 'bg-[#FFEFE9] text-[#FFEFE9] Inactive-column-cc'
                                                            : rowData.paymentMethod === 'Cash In Hand'
                                                                ? 'bg-[##FFFFE0] text-[#FF8F6B] Inactive-column'
                                                                : ''
                                                }`}
                                            >
                                                {rowData.paymentMethod}
                                            </div>
                                        );
                                    } else {
                                        return <span>N/A</span>;
                                    }
                                }}
                            />
                            <Column field="totalAmount" align="center" header="Total Amount" 
                            body={(rowData) => (
                                <span>{rowData?.status === "Approved" ? rowData?.totalAmount : 'N/A'}</span>
                            )}
                            />
                            <Column
                                field="paymentStatus"
                                header="Payment Status"
                                align="center"
                                body={(rowData) => {
                                    if (rowData?.status === "Approved") {
                                        return (
                                            <div
                                                className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${rowData.paymentStatus === 'Paid' ? 'bg-[#E6F4EA] text-[#3A974C] Active-column' : rowData.paymentStatus === 'UnPaid' ? 'bg-[#FFEFE9] text-[#FF8F6B] Inactive-column' : ''
                                                    }`}
                                            >
                                                {rowData.paymentStatus}
                                            </div>
                                        );
                                    } else {
                                        return <span>N/A</span>;
                                    }
                                }}
                            />

                            {/* <Column field="isRenew" header="isRenew" /> */}
                            <Column field="createdDate" header="Created On" />
                            <Column body={(rowData) => actionBodyTemplate(rowData)} />
                        </DataTable>
                        <div className="flex justify-content-between mt-1" style={{ borderTop: '1px solid #efefef' }}>
                            <Paginator template={template1} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" />
                            <Paginator template={template2} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} rowsPerPageOptions={[10, 25, 50]} />
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                header={
                    <div className="flex justify-content-between align-items-center px-4 py-2" style={{ height: '80px' }}>
                        <h3 className="m-0">QR Code Payment</h3>
                        <Button icon="pi pi-times" className="p-button-rounded p-button-text" onClick={onHideDialog} />
                    </div>
                }
                visible={qrDialogVisible}
                closable={true}
                onHide={onHideDialog}
                className="image-dialog qr-dialog"
                style={{ width: '90vw', maxWidth: '600px', borderRadius: '12px', zIndex: 1100 }}
                contentStyle={{ padding: '2rem', borderRadius: '0 0 12px 12px' }}
                modal={true}
                dismissableMask={true}
            >
                {qrCodeValue ? (
                    <div className="flex flex-column align-items-center text-center">
                        <h4 className="mb-3" style={{ fontWeight: '500', color: '#333' }}>
                            Scan QR Code for Online Payment
                        </h4>

                        <div className="my-3" style={{ background: '#f9f9f9', padding: '1.5rem', borderRadius: '10px' }}>
                            <QRCode value={qrCodeValue?.qrString} size={256} />
                        </div>

                        <p className="text-sm" style={{ color: '#555' }}>
                            Use QR Code or Consumer ID: <strong>{qrCodeValue?.consumerId}</strong> to complete your payment
                        </p>

                        <Button label="Close" onClick={onHideDialog} className="mt-4 p-button-secondary" style={{ borderRadius: '6px', padding: '0.75rem 2rem' }} />
                    </div>
                ) : (
                    <p className="text-center text-sm text-red-500">No QR data returned.</p>
                )}
            </Dialog>
        </>
    );
}

export default FitnessCertificateManagement;
